<template>
  <div>
    <div class="editor-wrapper">
      <h1>{{ $t('AccountBranding') }}:</h1>
      <br />
      <!-- The container where Monaco Editor will be rendered -->
      <div id="editor-container"></div>
      <vs-button @click="Save"
                 ref="markAsCompletedButton"
                 color="success" id="btn-complete"
                 class=""
                 style="width:100px; float:right;">
        {{ $t('Save') }}
      </vs-button>
    </div>
    <h1 class="mt-10">{{ $t('Favicon') }}:</h1>
    <div :style="'margin-right: 20px; position: relative;  float: left; width: 80px; height: 80px;'"
         onmousemove="this.classList.add('hover')"
         onmouseleave="this.classList.remove('hover')">
      <vs-avatar ref="avatar1"
                 size="64px"
                 style="display: inline-block; float: left"
                 :src="`/favicon.ico?nocache=${Date.now()}`" />
      <label class="custom-file-upload">
        <input class="avatar-hover"
               style="display:none;"
               type="file"
               @change="successUpload"
               ref="photoUpload" />
        <i class="fa fa-cloud-upload">...</i>
      </label>
    </div>
  </div>
</template>

<script>

  import * as monaco from 'monaco-editor';
  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

  export default {
    name: 'MonacoEditorComponent',
    props: {
      value: {
        type: String,
        default: '',
      },
      language: {
        type: String,
        default: 'json', // Default language for syntax highlighting
      },
    },
    data() {
      return {
        editor: null, // Reference to the Monaco Editor instance
      };
    },
    mounted() {
      var instance = this;
      var req = JSON.stringify({
        query: `query ApplicationSettings {
                  applicationSettings {
                    key,
                    value
                  }
                }`
      });

      self.MonacoEnvironment = {
        getWorkerUrl: function (moduleId, label) {
          return './monaco-editor-worker-loader-proxy.js'; // Adjust path as needed
        },
      };

      monaco.editor.defineTheme('TCVelikTheme', {
        base: 'vs', // Light theme as the base
        inherit: true,
        rules: [{ background: 'EDF9FA' }],
        colors: {
          'editor.selectionBackground': '#f2e7ff',
          'editor.inactiveSelectionBackground': '#f2e7ff',
        },
      });

      monaco.editor.setTheme('TCVelikTheme');

      // Initialize the Monaco Editor
      this.editor = monaco.editor.create(document.getElementById('editor-container'), {
        value: this.value,
        language: this.language,
        theme: 'TCVelikTheme',
        folding: true,
        minimap: { enabled: false },
        scrollbar: {
          handleMouseWheel: false,
          alwaysConsumeMouseWheel: false,
        },
        scrollBeyondLastColumn: false,
        scrollBeyondLastLine: false,
      });

      this.addShortcutKeys();

      TCVelikClient.PostRelative("/api/graphql", req, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      }).then(function (result) {
        if (result && result.data && result.data.data && result.data.data.applicationSettings && result.data.data.applicationSettings[0] != null) {
          instance.editor.setValue(result.data.data.applicationSettings[0].value);
        }
      });

    },
    methods: {
      addShortcutKeys() {
        this.editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, () => {
          // Get the editor content

          // Trigger your save logic
        });
      },

      async successUpload(evt) {
        var file = evt.srcElement.files[0];
        if (file) {
          let result_base64 = await new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
          });

          this.$refs.avatar1.src = result_base64 + "nocache";
          this.uploadImage(result_base64, file.name);
          // this.CommitPhotoField(this.Contact, result_base64, this.FieldName);
        }
      },

      async uploadImage(base64Image, imageFileName) {
        var instance = this;
        TCVelikClient.PostRelative("/api/admin/ChangeFavicon", {
          FileName: imageFileName, FileData: base64Image
        }).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: instance.$t('ChangedIcon'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemSavingIcon'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        })

      },

      fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(',')[1]); // Strip off metadata part
          reader.onerror = error => reject(error);
        });
      },

      Save() {
        const content = this.editor.getValue();
        var instance = this;
        const query = `mutation AddOrEditAppSettings($value: String!, $key: String!) {
                            addOrEditAppSettings(value: $value, key: $key) {

                            }
                        }`;

        var variables = {
          value: content,
          key: "AccountBranding"
        };

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response.data.data.addOrEditAppSettings === true) {
            alert(instance.$t('Saved'));
          }
        });
      }
    },
    beforeDestroy() {
      // Dispose of the editor instance to clean up resources
      if (this.editor) {
        this.editor.dispose();
      }
    },
  };
</script>

<style>
  /* Wrapper to ensure the editor fills the viewport */
  .editor-wrapper {
    display: flex;
    flex-direction: column;
    height: 60vh; /* Full viewport height */
    margin: 0;
  }

  /* Ensure the editor container fills available space */
  #editor-container {
    flex-grow: 1; /* Takes up remaining space in the wrapper */
    width: 100%;
  }

  .custom-file-upload {
    position: absolute;
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    bottom: 0px;
    right: 0px;
    background: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }
</style>
